export const FormItemTemplateConfig = [
    {
        name: "formItem",
        type: "container",
        values: [require("./template/form-item-container.template.html").default]
    },
    {
        name: "formItemContent",
        type: "content",
        values: [require("./template/form-item-content.template.html").default]
    },
]